import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getUserProfileById = async (id: string) => {
  const { data, error } = await supabase
    .from('user_profiles')
    .select(`
      *,
      expertProfile:salons_profile (*),
      privacy:profile_privacy_activity (id, activity, enabled)
    `)
    .eq('id', id)
    .single();
  if (error) {
    console.log('error here: ', error.message)
    throw new Error(error.message)
  }
  return data
}

export default function useProfileById(id: string) {
  return useQuery({
    queryKey: ['useProfileById', id],
    queryFn: () => getUserProfileById(id),
    enabled: Boolean(id),
  })
}
